import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";
import ViewDadosPessoais from "../views/ViewDadosPessoais";
import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import { useMediaQuery } from "react-responsive";
import { ArrowLeft } from "lucide-react";

const ScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  position: relative;
  background: linear-gradient(135deg, #003644, #0096c7);
`;

const ContentArea = styled.main`
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  min-height: calc(100vh - 160px);
  padding: 1rem;
  transform: translateY(-60px); /* 🔹 Sobe o formulário */
  transition: transform 0.3s ease;

  @media (max-width: 768px) {
    transform: translateY(-40px);
    padding: 0.5rem;
  }
`;

const BackButton = styled.button`
  position: absolute;
  top: 110px; /* distância abaixo do AppBar */
  left: 40px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 50%;
  padding: 0.6rem;
  cursor: pointer;
  color: #fff;
  transition: background 0.3s ease, transform 0.2s ease;
  z-index: 20;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.05);
  }

  svg {
    width: 22px;
    height: 22px;
  }

  @media (max-width: 768px) {
    top: 90px;
    left: 20px;
    padding: 0.5rem;
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

const ZapContainer = styled.div`
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 50;

  @media (max-width: 768px) {
    bottom: 15px;
    right: 15px;
  }
`;

const DadosPessoais: React.FC = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const handleVoltar = () => {
    // 🔙 Volta para a página anterior
    window.history.back();
  };

  return (
    <ScreenContainer>
      {/* Cabeçalho */}
      <ViewAppBar />

      {/* Botão / Seta de Voltar */}
      <BackButton onClick={handleVoltar} title="Voltar">
        <ArrowLeft />
      </BackButton>

      {/* Conteúdo central — formulário de dados pessoais */}
      <ContentArea>
        <ViewDadosPessoais />
      </ContentArea>

      {/* Rodapé */}
      <ViewFooter />

      {/* Botão flutuante do WhatsApp */}
      {!isMobile && (
        <ZapContainer>
          <ContatoZap />
        </ZapContainer>
      )}
    </ScreenContainer>
  );
};

export default DadosPessoais;
